import React, { useEffect, useState, useRef } from "react";
import OX_Grid from "../Grid/OX_Grid";

function QueryResult(props) {
  const refreshGrid = useRef(null);

  useEffect(() => {
    props.loader.destroy()
  }, [props.queryResult])

  return (
    <>
      <div className='row' style={{ marginLeft: "0.1em", marginRight: "0.1em" }}>
        <div className='col query-result-details'>
          Query Name: <span>{props.queryName ? props.queryName : "Test Query"}</span>
        </div>
        <div className='col query-result-details'>
          Execution Time:<span>{props.elapsedTime.toFixed(2)}ms</span>
        </div>
      </div>

      <div className='query-result-tab' id='query-result-tab'>
        {Array.isArray(props.queryResult) ? (
          <OX_Grid
            listOptions={{filterable: true}}
            ref={refreshGrid}
            core={props.core}
            dataSource={props.queryResult}
            filterable={true}
            reorderable={true}
            sortable={true}
            pageable={true}
            columnConfig={props.columns}
            elementId={'[data-id="Analytics_Window"]'}
          />
        ) : (
          <div className='query-result-text-tab'>
            <span>RESULT:</span>
            <span style={{ marginLeft: "2em" }}>{props.queryResult}</span>
          </div>
        )}
      </div>
    </>
  );
}
export default QueryResult;
